import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
axios.defaults.withCredentials = true

import state from './state'
import actions from './action'
import getters from './getter'
import modules from './module'

export default new Vuex.Store({
	state,
	actions,
	getters,
	modules
})
